export default "__VITE_ASSET__D0TQX$N6__"